import { Component, Injector, OnInit } from '@angular/core';
import { AgencyService } from '../common-theme/api/agency.service';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})

export class TermsComponent extends SeoAwareBaseComponent implements OnInit {
  constructor(
    public injector: Injector,
    public agencyService: AgencyService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.setTitle('Termeni și condiții - Dream Residence');

    this.setMetaDescription(
      `Termenii și condițiile de utilizare a site-ului Dream Residence: date de identificare,
      proprietate intelectuală, prelucrarea datelor cu caracter personal și soluționarea litigiilor.`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/terms/terms.component.ts